/**
 * @typedef {Object} MigrationStatus
 * @property {'residence'} Residence Вид на жительство (ВНЖ)
 * @property {'temporaryResidence'} TemporaryResidence Разрешение на временное проживание (РВП)
 * @property {'migrationCard'} MigrationCard Миграционная карта
 * @property {'other'} Other
 */

/** @type {Readonly<MigrationStatus>} */
const migrationStatus = {
    Residence: 'residence',
    TemporaryResidence: 'temporaryResidence',
    MigrationCard: 'migrationCard',
    Other: 'other',
};

/**
 * @typedef {Object} MigrationStatusItem
 * @property {string} caption надпись
 * @property {string} type техническое название
 */

/** @type {Record<MigrationStatus, MigrationStatusItem>} */
const migrationStatuses = {
    [migrationStatus.Residence]: {
        caption: 'Вид на жительство (ВНЖ)',
        type: migrationStatus.Residence,
    },
    [migrationStatus.TemporaryResidence]: {
        caption: 'Разрешение на временное проживание (РВП)',
        type: migrationStatus.TemporaryResidence,
    },
    [migrationStatus.MigrationCard]: {
        caption: 'Миграционная карта',
        type: migrationStatus.MigrationCard,
    },
    [migrationStatus.Other]: {
        caption: 'Другой',
        type: migrationStatus.Other,
    },
};

module.exports = {
    MIGRATION_STATUS: migrationStatus,
    MIGRATION_STATUSES: migrationStatuses,
};
